import { Method } from 'axios';

export interface BookingAPIEndpoint {
    url: string;
    method: Method;
}

const BookingAPIBasePath = '/bookingAPI';
// cf-turnstile-response
export const HEADER_CF_TURNSTILE_RESPONSE = 'cf-turnstile-response';
// Authorization
export const HEADER_AUTHORIZATION = 'Authorization';

const merchantAreasPath = {
    init: (merchantId: string): BookingAPIEndpoint => ({
        url: `${BookingAPIBasePath}/merchants/${merchantId}/merchantAreas`,
        method: 'POST'
    }),
    query: (merchantId: string): BookingAPIEndpoint => ({
        url: `${BookingAPIBasePath}/merchants/${merchantId}/merchantAreas`,
        method: 'GET'
    }),
    update: (merchantId: string): BookingAPIEndpoint => ({
        url: `${BookingAPIBasePath}/merchants/${merchantId}/merchantAreas`,
        method: 'PUT'
    })
};

export const bookingAPIPath = {
    merchant: {
        query: (merchantId: string): BookingAPIEndpoint => ({
            url: `${BookingAPIBasePath}/merchants/${merchantId}`,
            method: 'GET'
        }),
        areas: merchantAreasPath,
        queryBookingLink: (merchantId: string): BookingAPIEndpoint => {
            return {
                // url: "merchants/:merchantId/shortLink",
                url: `${BookingAPIBasePath}/merchants/${merchantId}/shortLink`,
                method: 'GET'
            };
        }
    },
    public: {
        updateBookingByCustomer: (merchantId: string): BookingAPIEndpoint => ({
            url: `${BookingAPIBasePath}/public/booking/${merchantId}`,
            method: 'PUT'
        }),
        createBookingByCustomer: (merchantId: string): BookingAPIEndpoint => ({
            url: `${BookingAPIBasePath}/public/booking/${merchantId}`,
            method: 'POST'
        }),
        queryBookingAvailableTime: (merchantId: string): BookingAPIEndpoint => ({
            url: `${BookingAPIBasePath}/public/${merchantId}/availableBookingTime`,
            method: 'GET'
        })
    },
    booking: {
        query: (merchantId: string, yearStr: string, bookingNumber: string): BookingAPIEndpoint => ({
            url: `${BookingAPIBasePath}/booking/${merchantId}/${yearStr}/${bookingNumber}`,
            method: 'GET'
        }),
        updateByStaff: (merchantId: string): BookingAPIEndpoint => ({
            url: `${BookingAPIBasePath}/booking/${merchantId}`,
            method: 'PUT'
        }),
        updateBookingSettings: (merchantId: string): BookingAPIEndpoint => ({
            url: `${BookingAPIBasePath}/booking/${merchantId}/settings`,
            method: 'PUT'
        }),
        queryBookingSettings: (merchantId: string): BookingAPIEndpoint => ({
            url: `${BookingAPIBasePath}/booking/${merchantId}/settings`,
            method: 'GET'
        }),
        queryBookingList: (merchantId: string): BookingAPIEndpoint => ({
            url: `${BookingAPIBasePath}/booking/${merchantId}`,
            method: 'GET'
        }),
        queryBookingAvailableTime: (merchantId: string): BookingAPIEndpoint => ({
            url: `${BookingAPIBasePath}/booking/${merchantId}/availableBookingTime`,
            method: 'GET'
        })
    }
};
